// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Component, ViewChild, Input, Output, OnInit, EventEmitter, ElementRef } from '@angular/core';
@Component({
  selector: 'app-logo-upload',
  templateUrl: './logo-upload.component.html',
  styleUrls: ['./logo-upload.component.scss']
})
export class LogoUploadComponent implements OnInit {
  @ViewChild('fileInput') fileInput!: ElementRef;
  @Input() currentLogoSrc: string | undefined = undefined;
  @Output() fileAdded = new EventEmitter<File | undefined>();

  shouldDisplayNoLogoText = false;
  uploadedFile: File | undefined = undefined;
  imgSrc: string | undefined = undefined;

  // Prevent showing cached image by appending src with modified time
  modified = Date.now();

  constructor() {}

  ngOnInit() {}

  fileChanged(e: Event) {
    const target: HTMLInputElement = e.target as HTMLInputElement;
    this.uploadedFile = this.getUploadedFile(target);
    this.imgSrc = window.URL.createObjectURL(this.uploadedFile);
    this.fileAdded.emit(this.uploadedFile);
  }

  reset() {
    this.fileInput.nativeElement.value = '';
    this.uploadedFile = undefined;
    this.imgSrc = undefined;
    this.fileAdded.emit(undefined);
    this.shouldDisplayNoLogoText = false;
    this.modified = Date.now();
  }

  handleNoLogo() {
    this.shouldDisplayNoLogoText = true;
  }

  private getUploadedFile(target: HTMLInputElement) {
    return target === null || target.files === null ? undefined : target.files[0];
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/logo-upload/logo-upload.component.ts